import React from 'react';
import { AI_TRAINER_PERSONALITIES } from '../../constants/aiTrainerPersonalities';
import { aiTrainerHeadingClassName, aiTrainerMutedTextClassName, PERSONA_PICKER_IDLE, PERSONA_PICKER_SELECTED } from './aiTrainerStyles';

export default function AiTrainerPersonaPicker({ value, onChange, disabled = false }) {
	return (
		<div className="grid gap-3 md:grid-cols-2">
			{AI_TRAINER_PERSONALITIES.map((persona) => {
				const selected = value === persona.id;

				return (
					<button
						key={persona.id}
						type="button"
						disabled={disabled}
						onClick={() => onChange(persona.id)}
						className={[
							'text-left rounded-xl border-2 p-4 transition-all',
							selected ? PERSONA_PICKER_SELECTED[persona.id] : PERSONA_PICKER_IDLE,
							disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'
						].join(' ')}
					>
						<div className="flex items-start gap-3">
							<span className="text-3xl" aria-hidden>
								{persona.emoji}
							</span>
							<div>
								<div className={`font-semibold ${aiTrainerHeadingClassName}`}>{persona.label}</div>
								<div className={aiTrainerMutedTextClassName}>{persona.tagline}</div>
								{selected && (
									<div className={`mt-2 text-sm italic ${aiTrainerMutedTextClassName}`}>
										"{persona.sampleLine}"
									</div>
								)}
							</div>
						</div>
					</button>
				);
			})}
		</div>
	);
}
